// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xPZhg","textPreview":"styles_textPreview__ATQKt","preview":"styles_preview__H6TOl","paletteGrid":"styles_paletteGrid__7gQ6-"};